import TreeList, { Column, Scrolling } from "devextreme-react/tree-list";
import { useUser } from "../../../../../hook";
import { Employee } from "../../../../../services/department-viags/employee-viags.service";
import { usePublicDocumentContent } from "../../../hooks/published-documents/use-public-document-content";
import { Spin } from "antd";
import { useSearchParams } from "../../../../../hook/use-search-params";

export const HistoryVersionContentV2 = () => {
  const { groupedData, isLoading, docPublicData, maxVersion } = usePublicDocumentContent();
  const { checkCurrentUser } = useUser();
  const { searchParams } = useSearchParams();
  const version = searchParams.get("version");
  const documentVersion = version ? +version : maxVersion;

  const contentCellRender = (cellInfo: any) => {
    const id = `title-${cellInfo.data.Id}`;
    return cellInfo.data.Permissions?.findIndex((e: Employee) => checkCurrentUser(e.employeeEmail)) > -1 ||
      !cellInfo.data.IsContent ||
      !cellInfo.data.isContentPermission ||
      checkCurrentUser(docPublicData?.userEmail || "") ? (
      <div
        id={id}
        style={{ whiteSpace: "normal", padding: "1px", margin: "1px", userSelect: "none" }}
        className="scroll-mt-20"
        dangerouslySetInnerHTML={{ __html: cellInfo.value }}
      />
    ) : (
      <></>
    );
  };

  if (isLoading) return <Spin />;
  
  return (
    <TreeList
      wordWrapEnabled={true}
      id={`content__custom-editor_${0}`}
      dataSource={groupedData[documentVersion]}
      showRowLines={false}
      showBorders={false}
      columnAutoWidth={true}
      showColumnHeaders={false}
      showColumnLines={false}
      allowColumnReordering={false}
      allowColumnResizing={false}
      keyExpr="CustomId"
      parentIdExpr="CustomParentId"
      autoExpandAll={true}
    >
      <Scrolling mode="standard" />
      <Column
        width="700px"
        fixed={true}
        fixedPosition="left"
        allowResizing={true}
        dataField="Content"
        alignment="left"
        allowSorting={false}
        dataType="string"
        cellRender={contentCellRender}
        cssClass="white-space: normal!important"
      ></Column>
    </TreeList>
  );
};
